import { render } from "./DeleteAccountDialog.vue?vue&type=template&id=59891497"
import script from "./DeleteAccountDialog.vue?vue&type=script&lang=js"
export * from "./DeleteAccountDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__